export const BILLING_DASHBOARD_PAGE = '/billing';
export const BILLING_TRANSACTIONS_PAGE = '/billing/transactions';
export const BILLING_TOP_UP_RESULT = '/billing/top-up/result';
